var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-with-label-component",class:{ '--dense': _vm.dense }},[_c('div',{staticClass:"d-none d-md-block label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"text",class:_vm.textClassList},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }